export interface ParsedExcelSheet {
  actualLastRowNumber?: number;
  hasExpectedHeader?: boolean;
  hasOnlyExpectedHeader?: boolean;
  hasData?: boolean;
  getCellValue?: (headerName: string, rowNumber: number) => string;
  firstColumnValidationError?: ExcelSheetColumnValidationError;
};

export interface ExcelSheetColumnValidationError {
  errorType: ExcelSheetColumnValidationErrorType;
  errorCode: string;
  headerName: string;
};

export enum ExcelSheetColumnValidationErrorType {
  Mandatory,
  DataType
};
